import { inject } from '@angular/core';
import { dispatch, Store } from '@ngxs/store';
import { filter, map, of, take } from 'rxjs';
import { CourseStateActions } from './course-state.actions';
import { CourseState } from './course.state';
import * as i0 from "@angular/core";
export let CourseStateFacade = /*#__PURE__*/(() => {
  class CourseStateFacade {
    constructor() {
      this.store = inject(Store);
      this.reloadCourses = dispatch(CourseStateActions.ReloadCourses);
      this.selectCourse = dispatch(CourseStateActions.SelectCourse);
      this.selectScene = dispatch(CourseStateActions.SelectScene);
      this.clearSelectedCourse = dispatch(CourseStateActions.ClearSelectedCourse);
      this.clearSelectedScene = dispatch(CourseStateActions.ClearSelectedScene);
      this.selectNextScene = dispatch(CourseStateActions.SelectNextScene);
      this.saveCurrentSceneProgress = dispatch(CourseStateActions.SaveCurrentSceneProgress);
      this.setListFilters = dispatch(CourseStateActions.SetListFilters);
      this.resetListFilters = dispatch(CourseStateActions.ResetListFilters);
    }
    initialize(refreshIfAlreadyInitialized = true) {
      const alreadyInitialized = this.store.selectSnapshot(CourseState.initialized);
      if (!refreshIfAlreadyInitialized && alreadyInitialized) return of(true);
      this.store.dispatch(new CourseStateActions.Initialize());
      if (alreadyInitialized) {
        // no need to wait for anything to load as its already loaded!
        return of(true);
      } else {
        return this.store.select(CourseState.courses).pipe(filter(c => !c || !c.length), take(1), map(() => true));
      }
    }
    static {
      this.ɵfac = function CourseStateFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CourseStateFacade)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CourseStateFacade,
        factory: CourseStateFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CourseStateFacade;
})();